// App.tsx
import { Routes, Route } from 'react-router-dom';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Home from './components/home/Home';
import SafetyProducts from './components/safetyProducts/SafetyProducts';
import DisposableProducts from './components/disposableProducts/DisposableProducts';
import SurgicalProducts from './components/surgicalProducts/SurgicalProducts';
import FurnitureProducts from './components/furnitureProducts/FurnitureProducts';
import FloatingWhatsAppButton from './components/shared-components/FloatingContactButtons';


export default function App(){
  return (
    <>
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/safety" element={<SafetyProducts/>}/>
        <Route path="/disposable" element={<DisposableProducts/>}/>
        <Route path="/surgical" element={<SurgicalProducts/>}/>
        <Route path="/furniture" element={<FurnitureProducts/>}/>
      </Routes>
      <Footer/>
      <FloatingWhatsAppButton />
    </>
  );
}
